module.exports = __webpack_public_path__ + "img/颜色映射.3b9e3697.svg";